<template>
    
</template>

<script>
import axios from "axios";

export default {
    name: 'Logout',
    mounted() {
        axios({
            method: "GET",
            url: this.$httpAxiosBaseUrl() + "Login/Logout?date=" + new Date().getTime()
        }).then(result => {
            var response = result.data;
            if (response === '') {       
                this.$router.push({ name: "Login" });
            } else {
                // SSO redirection/timeout
                var ssoRedirectUrl = response;
                window.location = this.$formatOldCustomerPortalLinks(this.$httpAxiosBaseUrl(), ssoRedirectUrl);            
            }  
            
            // Call 'resetApp' action on the store which will reset some of our information back to it's original state
            this.$store.dispatch('resetApp');
        }, error => {
            console.log(error);
        });
    }
}
</script>

